import { render, staticRenderFns } from "./ZyroInfo.vue?vue&type=template&id=4faa0ae2&scoped=true&"
import script from "./ZyroInfo.vue?vue&type=script&lang=js&"
export * from "./ZyroInfo.vue?vue&type=script&lang=js&"
import style0 from "./ZyroInfo.vue?vue&type=style&index=0&id=4faa0ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faa0ae2",
  null
  
)

export default component.exports